import { Put } from '../helpers';

const UnlockEmail = (email: string): Promise<{ unlocked_email: string }> => {
  return Put({ url: '/v3/admin/auth/unlock-profile', body: { email_to_unlock: email } });
};

export default UnlockEmail;
